import { PureSwitcher } from '../../../../common/ui/pure-switcher/pure-switcher'
import styles from '../styles/roles.page.module.scss'

interface RoleAccessToggleProps {
  label: string
  value?: boolean
  onChange?: (event: { target: { value: boolean; name?: string } }) => void
  name?: string
}

export const RoleAccessToggle = ({ label, value, onChange, name }: RoleAccessToggleProps) => {
  const handleChange = (checked: boolean) => {
    onChange?.({
      target: {
        value: checked,
        name: name,
      },
    })
  }

  return (
    <div className="switchRow d-flex justify-content-between align-items-center border rounded p-2 mb-2">
      <PureSwitcher
        colClass={styles.roleSwitcher}
        isChecked={!!value}
        label={[label, label]}
        onChange={handleChange}
        position="right"
      />
    </div>
  )
}
